const FUNDS_SOURCE_YOURSELF_LIST = [
    {
        value: 'TRANSFER_FROM_OWN_ACCOUNT',
        en: 'Transfer from your own accounts (including non-HSBC accounts)',
        zh_CN: '由本人账户转入（包括非汇丰账户）',
        zh_HK: '由本人戶口轉入（包括非滙豐戶口）'
    },
    {
        value: 'PERSONAL_CASH_SAVINGS',
        en: 'Personal cash savings',
        zh_CN: '个人现金存款',
        zh_HK: '個人現金存款'
    }
];

const FUNDS_SOURCE_THIRD_LIST = [
    {
        value: 'CHEQUE',
        en: 'Cheque',
        zh_CN: '支票',
        zh_HK: '支票'
    },
    {
        value: 'SOCIAL_SECURITY_BENEFITS',
        en: 'Social security benefits',
        zh_CN: '社会保障福利津贴',
        zh_HK: '社會保障福利津貼'
    },
    {
        value: 'TRANSFER_FROM_ANOTHER_ACCOUNT',
        en: "Transfer from another person's account or company",
        zh_CN: '由其他个人或公司账户转入',
        zh_HK: '由其他個人或公司戶口轉入',
        isCountry: true
    },
    {
        value: 'GIFT_OR_SALE_OF_PERSONAL_GOODS',
        en: 'Cash received from gifts or sale of personal goods',
        zh_CN: '他人赠予或个人物品售卖所得资金',
        zh_HK: '他人贈予或個人物品售賣所獲得的資金',
    },
    {
        value: 'ANOTHER_SOURCE',
        en: 'Cash from another source',
        zh_CN: '其他资金来源',
        zh_HK: '其他資金來源',
        isOther: true
    }
]

export default {
    FROM_YOURSELF: FUNDS_SOURCE_YOURSELF_LIST,
    THIRD_PARTY: FUNDS_SOURCE_THIRD_LIST,
}
